/**
 * Sidebar UI state: whether the rail is collapsed to icons, and which nav groups
 * are expanded. Persisted to localStorage so it survives navigation (each admin
 * page mounts its own shell) and reloads. Mirrors the community store pattern.
 */
const LS_KEY = 'sg_admin_nav';

type NavState = { collapsed: boolean; open: Record<string, boolean> };

function load(): NavState {
  const fallback: NavState = { collapsed: false, open: { insights: true, community: true, ai: true, settings: true } };
  try {
    const raw = localStorage.getItem(LS_KEY);
    if (!raw) return fallback;
    const parsed = JSON.parse(raw) as Partial<NavState>;
    return {
      collapsed: Boolean(parsed.collapsed),
      open: { ...fallback.open, ...(parsed.open ?? {}) },
    };
  } catch {
    return fallback;
  }
}

export const nav = $state<NavState>(load());

function persist(): void {
  try {
    localStorage.setItem(LS_KEY, JSON.stringify({ collapsed: nav.collapsed, open: nav.open }));
  } catch {
    /* ignore */
  }
}

export function toggleCollapsed(): void {
  nav.collapsed = !nav.collapsed;
  persist();
}

/** Expand/collapse a nav group by id. */
export function toggleGroup(id: string): void {
  nav.open[id] = !nav.open[id];
  persist();
}
